module.exports = __webpack_public_path__ + "img/2.b361a5d6.jpg";